import { render } from "./RadioButton.vue?vue&type=template&id=6df50868&scoped=true&ts=true"
import script from "./RadioButton.vue?vue&type=script&lang=ts"
export * from "./RadioButton.vue?vue&type=script&lang=ts"

import "./RadioButton.vue?vue&type=style&index=0&id=6df50868&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6df50868"]])

export default __exports__